import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import DateRangePopover from "./DateRangePopover";

export default function ValidityDateRangePicker({
  value,
  onChange,
  label,
  disabled,
  className,
  portal,
}) {
  const { t } = useTranslation("common");
  const resolvedLabel = label === undefined ? t("validity.period") : label;

  return (
    <div className={`rec-field${className ? ` ${className}` : ""}`}>
      {resolvedLabel && (
        <span className="text-[12.5px] font-semibold text-ink-2">{resolvedLabel}</span>
      )}
      <div className="self-start">
        <DateRangePopover
          mode="validity"
          value={value}
          onChange={onChange}
          ariaLabel={resolvedLabel || t("validity.period")}
          disabled={disabled}
          portal={portal}
        />
      </div>
    </div>
  );
}

ValidityDateRangePicker.propTypes = {
  value: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  portal: PropTypes.bool,
};

ValidityDateRangePicker.defaultProps = {
  label: undefined,
  disabled: false,
  className: undefined,
  portal: false,
};
